<template>
	<section class="navigation-mobile-header">
		<v-btn 
			icon
			@click="openNavigation">
			<v-icon class="white--text">menu</v-icon>
		</v-btn>
	</section>
</template>


<script>
	import { mapActions, mapState } from 'vuex'
	// import { mapFields } from 'vuex-map-fields'
	import { VUEX_UI_SHOW_NAVIGATION_DRAWER, VUEX_UI_HIDE_NAVIGATION_DRAWER } from '@/store/constants/ui'

	export default {
		name: 'navigation-mobile-header',

		computed: {
			...mapState({
				openState: state => state.ui.navigationDrawer.openState,
			})
		},
		methods: {
			...mapActions({
				openDrawer: VUEX_UI_SHOW_NAVIGATION_DRAWER,
				closeDrawer: VUEX_UI_HIDE_NAVIGATION_DRAWER
			}),
			openNavigation() {
				if (this.openState === false) {
					this.openDrawer()
					let that = this
					const navOpened = function() {
						if (event.target.closest('.navigation-drawer') || event.target.closest('.navigation-mobile-header')) return;
						if (that.openState === true) that.closeDrawer()
						document.removeEventListener('touchstart', navOpened);
					}
					document.addEventListener('touchstart', navOpened)
				} else {
					this.closeDrawer()
				}
			}
		}
	}
</script>